/**
 * 包括契約検索API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 包括契約検索情報
 */
export interface Sgkb702aReqInclusioncontractSearchInfoDto {
    /** 
     * 契約担当部署番号：数字
     */
    ctrTantobushoNo?: string;
    /** 
     * 契約担当者番号：英数字
     */
    ctrTntshNo?: string;
    /** 
     * 契約担当者：全角
     */
    ctrTntsh?: string;
    /** 
     * 包括お客さま番号：数字
     */
    inclusioncontractVisitornumber?: string;
    /** 
     * 包括お客さま名：全角
     */
    inclusioncontractVisitormei?: string;
    /** 
     * 申請状況：数字
     */
    appJokyo?: string;
    /** 
     * 契約終了日（開始）：日付(yyyyMMdd)
     */
    ctrEnddtStart?: string;
    /** 
     * 契約終了日（終了）：日付(yyyyMMdd)
     */
    ctrEnddtEnd?: string;
    /** 
     * 過去契約も含む：数字
     */
    kakoCtrContain?: string;
    /** 
     * 包括契約履歴番号：数字
     */
    inclusioncontractRrkno?: string;
    /** 
     * 包括契約年度内通番号：数字
     */
    inclusioncontractYearnaiSrno?: string;
}
